/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable jsx-a11y/anchor-has-content */
import React, { memo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import cn from 'classnames';
import { useSelector } from 'react-redux';
import { Trans } from '../../src/i18n';
import { TP } from '../../constants/consts';
import route from '../../constants/routes';
import { selectBanner } from '../../containers/App/selectors';
import { colors } from '../../constants/styleConstants';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    justifyContent: 'space-around',
    padding: 5,
    fontSize: 20,
  },
  expired: {
    color: colors.white,
    backgroundColor: colors.primary,
    '& a': {
      color: colors.white,
      textDecoration: 'underline',
    },
  },
}));

const NotificationBanner = () => {
  const classes = useStyles();
  const banner = useSelector(selectBanner());

  switch (banner?.type) {
    case 'expired-sub':
      return (
        <div className={cn(classes.root, classes.expired)}>
          <span>
            <Trans
              i18nKey={`${TP}.BANNERS_SUBSCRIPTION_EXPIRED`}
              components={{
                fblink: <a href={`${route.ACCOUNT_SUBSCRIPTIONS}`} />,
              }}
            />
          </span>
        </div>
      );

    default:
      return null;
  }
};

export default memo(NotificationBanner);
